var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pa-3", attrs: { align: "center", justify: "center" } },
    [
      _c(
        "v-card",
        { attrs: { align: "left", justify: "left" } },
        [
          _c(
            "v-card-text",
            { staticClass: "pa-3 font-weight-light white black--text" },
            [
              _c("v-icon", { staticClass: "primary--text lighten-2 pa-2" }, [
                _vm._v(" mdi-office-building-marker")
              ]),
              _vm._v("Cartórios > Listar Cartórios ")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-card",
            {
              staticClass: "pa-5 my-3",
              attrs: { elevation: "0" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.botaoListarCartorios.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "v-row",
                {},
                [
                  _c(
                    "v-col",
                    {
                      attrs: { cols: "3", xs: "2", sm: "2", md: "3", lg: "2" }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          solo: "",
                          elevation: "0",
                          "prepend-icon": "mdi-chevron-right",
                          "x-small": "",
                          label: "Código IBGE Cartório",
                          hint: "Informe o Código IBGE do cartório",
                          placeholder: "Ex.:0000349",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtros.cd_ibge_comarca,
                          callback: function($$v) {
                            _vm.$set(_vm.filtros, "cd_ibge_comarca", $$v)
                          },
                          expression: "filtros.cd_ibge_comarca"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: { cols: "4", xs: "2", sm: "2", md: "3", lg: "2" }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          solo: "",
                          small: "",
                          elevation: "0",
                          label: "Número do Cartório",
                          hint: "Informe o número para efetuar a busca",
                          placeholder: "Ex.: 1",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtros.nu_cartorio,
                          callback: function($$v) {
                            _vm.$set(_vm.filtros, "nu_cartorio", $$v)
                          },
                          expression: "filtros.nu_cartorio"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: { cols: "4", xs: "2", sm: "2", md: "3", lg: "3" }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          solo: "",
                          small: "",
                          label: "Nome do Cartório",
                          hint: "Informe o nome para efetuar a busca",
                          placeholder: "Ex.: Tabelionato",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtros.nm_cartorio,
                          callback: function($$v) {
                            _vm.$set(_vm.filtros, "nm_cartorio", $$v)
                          },
                          expression: "filtros.nm_cartorio"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: { cols: "10", xs: "2", sm: "2", md: "2", lg: "2" }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          solo: "",
                          small: "",
                          clearable: "",
                          items: _vm.listaUfs,
                          label: "UF",
                          "return-object": true
                        },
                        model: {
                          value: _vm.filtros.cd_uf,
                          callback: function($$v) {
                            _vm.$set(_vm.filtros, "cd_uf", $$v)
                          },
                          expression: "filtros.cd_uf"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: { cols: "3", xs: "2", sm: "2", md: "3", lg: "3" }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          solo: "",
                          small: "",
                          label: "Nome da Cidade",
                          hint: "Informe o nome da cidade",
                          placeholder: "Ex.: Curitiba",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filtros.nm_municipio,
                          callback: function($$v) {
                            _vm.$set(_vm.filtros, "nm_municipio", $$v)
                          },
                          expression: "filtros.nm_municipio"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right d-flex justify-end align-center",
                      staticStyle: { gap: "8px" },
                      attrs: { sm: "12", md: "12", lg: "12" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary white--text",
                            "data-cy": "criarCartorioBtn"
                          },
                          on: {
                            click: function($event) {
                              _vm.dialogCriar = true
                            }
                          }
                        },
                        [
                          _vm._v(" Criar Cartório "),
                          _c("v-icon", { staticClass: "ml-2" }, [
                            _vm._v("mdi-plus")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "green white--text",
                            "data-cy": "buscarCartoriosBtn"
                          },
                          on: { click: _vm.botaoListarCartorios }
                        },
                        [
                          _vm._v(" Buscar Cartórios "),
                          _c("v-icon", { staticClass: "ml-2" }, [
                            _vm._v("search")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.snackbar
            ? _c("Snackbar", {
                attrs: {
                  mostrarSnackbar: _vm.snackbar,
                  corSnackbar: _vm.snackbarColor,
                  mensagemSnackbar: _vm.mensagemRetorno
                },
                on: {
                  fecharSnackbar: function($event) {
                    _vm.snackbar = false
                  }
                }
              })
            : _vm._e(),
          _c("v-data-table", {
            staticClass: "elevation-1 pa-3",
            attrs: {
              "data-cy": "dataTableCartorios",
              loading: _vm.loading,
              "no-data-text": "Não há cartórios listados",
              "loading-text": "Carregando Cartórios...",
              headers: _vm.headers,
              items: _vm.cartorios,
              "item-key": "cartorios",
              "footer-props": {
                itemsPerPageOptions: [10, 20, 50, -1],
                itemsPerPageText: "Cartórios por página:"
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.st_ativo`,
                  fn: function({ item }) {
                    return [
                      _c("v-switch", {
                        style: {
                          color: item.st_ativo != "" ? "green" : "red"
                        },
                        attrs: {
                          color: item.st_ativo != "" ? "green" : "red",
                          readonly: "",
                          inset: ""
                        },
                        model: {
                          value: item.st_ativo,
                          callback: function($$v) {
                            _vm.$set(item, "st_ativo", $$v)
                          },
                          expression: "item.st_ativo"
                        }
                      })
                    ]
                  }
                },
                {
                  key: `item.is_admin`,
                  fn: function({ item }) {
                    return [
                      _c(
                        "v-icon",
                        {
                          style: {
                            color: item.is_admin != "" ? "green" : "red"
                          }
                        },
                        [_vm._v(_vm._s(_vm.getBolean(item.is_admin)))]
                      )
                    ]
                  }
                },
                {
                  key: `item.status`,
                  fn: function({ item }) {
                    return [
                      item.status == "true"
                        ? _c("span", [_c("p", [_vm._v("Ativo")])])
                        : _vm._e(),
                      item.cd_status == "false"
                        ? _c("span", [_c("p", [_vm._v("Desabilitado")])])
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "item.action",
                  fn: function(props) {
                    return [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2 white--text",
                          attrs: {
                            elevation: "0",
                            small: "",
                            loading: _vm.loadingVerCartorioId === props.item.id,
                            color: "#3E4D7A",
                            "data-cy": `editarCartorio${props.index}`
                          },
                          on: {
                            click: function($event) {
                              return _vm.exibirDetalhe(props.item)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { small: "" } },
                            [_vm._v("mdi-office-building-marker")]
                          ),
                          _vm._v("Ver Cartório ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            elevation: "0",
                            small: "",
                            text: "",
                            color: "red",
                            "data-cy": `deletarCartorio${props.index}`
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmarDelecao(props.item)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-1", attrs: { small: "" } },
                            [_vm._v("mdi-delete")]
                          ),
                          _vm._v("Excluir ")
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _vm.dialogCriar
        ? _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "1200px",
                persistent: "",
                scrollable: "",
                color: "background",
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.dialogCriar,
                callback: function($$v) {
                  _vm.dialogCriar = $$v
                },
                expression: "dialogCriar"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { flat: "", dark: "", color: "primary" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: {
                                click: function($event) {
                                  _vm.dialogCriar = false
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                          _c("v-toolbar-title", [_vm._v("Criar Cartório")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    { staticClass: "px-8 py-4" },
                    [
                      _c("CriarCartorio", {
                        ref: "criarCartorioForm",
                        attrs: { validarForm: _vm.validarFormCriar },
                        on: {
                          formValidado: function($event) {
                            _vm.validarFormCriar = $event
                          },
                          setIsInvalid: function($event) {
                            _vm.isInvalidCriar = $event
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "end",
                        padding: "8px 48px 8px 16px"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-5",
                          attrs: {
                            color: "success white--text",
                            loading: _vm.loadingCriar,
                            "data-cy": "salvarCartorioBtn"
                          },
                          on: { click: _vm.salvarNovoCartorio }
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("mdi-content-save")
                          ]),
                          _vm._v("Salvar ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-5",
                          attrs: { color: "grey white--text" },
                          on: {
                            click: function($event) {
                              _vm.dialogCriar = false
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("mdi-close")
                          ]),
                          _vm._v("Cancelar ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          model: {
            value: _vm.dialogDeletar,
            callback: function($$v) {
              _vm.dialogDeletar = $$v
            },
            expression: "dialogDeletar"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Confirmar Exclusão")
              ]),
              _c("v-card-text", [
                _vm._v(" Tem certeza que deseja excluir o cartório "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.cartorioParaDeletar
                        ? _vm.cartorioParaDeletar.nm_cartorio
                        : ""
                    )
                  )
                ]),
                _vm._v("? Esta ação não pode ser desfeita. ")
              ]),
              _c(
                "v-card-actions",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    padding: "8px 24px"
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red white--text",
                        loading: _vm.loadingDeletar,
                        "data-cy": "confirmarDelecaoBtn"
                      },
                      on: { click: _vm.deletarCartorio }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("mdi-delete")
                      ]),
                      _vm._v("Excluir ")
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey white--text" },
                      on: {
                        click: function($event) {
                          _vm.dialogDeletar = false
                        }
                      }
                    },
                    [_vm._v(" Cancelar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.dialogEditar
        ? _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "1200px",
                persistent: "",
                scrollable: "",
                color: "background",
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.dialogEditar,
                callback: function($$v) {
                  _vm.dialogEditar = $$v
                },
                expression: "dialogEditar"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { flat: "", dark: "", color: "primary" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: { click: _vm.closeDialogEditar }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "2", align: "left" } },
                            [
                              _c("v-toolbar-title", [
                                _vm._v("Visualizar Cartório")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    { staticClass: "px-8 py-4" },
                    [
                      _c("EditarCartorio", {
                        attrs: {
                          cartorio: _vm.cartorio,
                          validarForm: _vm.validarForm
                        },
                        on: {
                          formValidado: function($event) {
                            _vm.validarForm = $event
                          },
                          setIsInvalid: function($event) {
                            _vm.isInvalid = $event
                          },
                          fecharModal: _vm.closeDialogEditar
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "end",
                        padding: "8px 48px 8px 16px"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-5",
                          attrs: {
                            color: "success white--text",
                            loading: _vm.loadingSalvar
                          },
                          on: { click: _vm.validarSalvarCartorio }
                        },
                        [
                          _c("v-icon", {}, [_vm._v("mdi-chevron-right")]),
                          _vm._v("Salvar Alterações ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-5",
                          attrs: { color: "grey white--text" },
                          on: { click: _vm.closeDialogEditar }
                        },
                        [
                          _c("v-icon", {}, [_vm._v("mdi-chevron-right")]),
                          _vm._v("Fechar ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }